import React, {FC} from 'react';
import styled from 'styled-components';

import {ChromelessButton, ChromelessButtonProps} from './chromelessButton';

/*
 * Props.
 */

export interface InlineLinkButtonProps {
  className?: string;
  color?: string;
  hoverColor?: string;
  hasTextDecoration?: boolean;
}

/*
 * Style.
 */

type WrapperProps = ChromelessButtonProps & InlineLinkButtonProps;
const StyledLinkButton = styled(ChromelessButton)<WrapperProps>`
  display: inline;
  color: ${(p) => p.color || p.theme.interactiveText};
  text-decoration: ${(p) => p.hasTextDecoration && 'underline'};

  cursor: pointer;

  &:hover {
    color: ${(p) => p.hoverColor || p.theme.interactiveTextHover};
  }
`;

/*
 * Component.
 */

/** An inline button styled to appear as an ordinary link. */
export const InlineLinkButton: FC<WrapperProps> = (props) => <StyledLinkButton {...props} />;
